/* eslint-disable max-len */
import { PayloadAction, RESET_STATE } from '../types/global';
import {
  GET_COUNTIES, GET_STATES, GET_PHYSICIANS, Lookup, GET_PROFESSIONS
} from '../types/lookup';

export interface LookupState {
  counties: Lookup,
  states: Lookup,
  physicians: Lookup,
  professions: Lookup
}

const INITIAL_STATE: LookupState = {
  counties: null,
  states: null,
  physicians: null,
  professions: null
};

const lookupReducer = function (state: LookupState = INITIAL_STATE, action: PayloadAction<any>): LookupState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_COUNTIES:
      return { ...state, counties: action.payload.map((e) => ({ id: e.countyId, name: e.countyName } as Lookup)) };
    case GET_STATES:
      return { ...state, states: action.payload.map((e) => ({ id: e.stateId, name: e.stateName } as Lookup)) };
    case GET_PHYSICIANS:
      return {
        ...state, physicians: action.payload.map((e) => ({ id: e.physicianUserIdEncrypted, name: e.physicianName, nameFormatted: e.physicianNameFormatted } as Lookup))
      };
    case GET_PROFESSIONS:
      return {
        ...state, professions: action.payload.map((e) => ({ id: e.professionId, name: `${e.description} (${e.code})`, code: e.code } as Lookup))
      };
    default:
      return state;
  }
};

export default lookupReducer;
